'use strict';

export const default_domain = "/";
export const default_name = "userBearerToken";
